<template>
    <div class="game-main" :style="{ height: mainHeight + 'px' }" v-loading="loading">
        <div class="game-main-content">
            <el-row>
                <game-header></game-header>
            </el-row>
            <el-row>
                <el-col v-for="index in productLevels" :key="index" :span="24" class="img-level-col">
                    <img @click="handleLevelClick(index)" class="img-level"
                        :src="require('@/assets/images/game/game-level' + (index) + '.png')">
                    <el-row style="margin: 0 auto;">
                        <el-col v-if="index === currentLevel" v-for="level in unitInfo" :key="level.unit" :span="12">
                            <el-card :class="card.cardClass[level.unit - 1]" :body-style="{ padding: '10px' }">
                                <div slot="header" class="clearfix" @click="handleClick(index - 1, level.unit)">
                                    <el-badge :value="level.unit" class="item" type="primary" style="width: 100%;">
                                        <div style="max-height: 60px;overflow: hidden;">
                                            <span>{{ level.unitName }}</span>
                                        </div>
                                    </el-badge>
                                </div>
                                <div @click="handleClick(index, level.unit)" style="width: 100%;">
                                    <el-tag size="mini"><span class="img-level-card-words">{{
                                        level.counts }}</span>words</el-tag>
                                    <el-progress
                                        :percentage="level.percentage > 100 ? 100 : level.percentage"></el-progress>
                                </div>
                                <div v-if="level.percentage > 0">
                                    <el-tag size="mini"><span>总得分:</span><span class="img-level-card-score">{{
                                        level.score }}</span></el-tag>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-dialog v-loading="loading" :title="gameType" :visible.sync=centerDialogVisible width="100%"
                    fullscreen :center="true">
                    <div>
                        <sound-templete :gameData="soundData" @reload-data="loadGames" :game-type="gameType"
                            :difficultyList="difficultyList" @save-answer="saveAnswer"></sound-templete>
                    </div>
                </el-dialog>
            </el-row>
        </div>
    </div>
</template>
<script>
import api from '@/utils/api'
import Enumerable from 'linq'
import hedaer from '../../../components/game/head.vue'
import soundtemplete from '../../../components/game/soundtemplete.vue'
// import VConsole from 'vconsole'
export default {
    components: {
        'game-header': hedaer,
        'sound-templete': soundtemplete
    },
    data () {
        return {
            loading: false,
            mainHeight: window.innerHeight,
            productLevels: [],
            unitInfo: [],
            curentProcuctSeries: 2, // 128xil
            currentLevel: 0,
            curentUnit: 1,
            gameType: '',
            difficultyList: [],
            centerDialogVisible: false,
            card: {
                cardClass: [],
                cardSelected: false
            },
            soundData: []
        }
    },
    created () {
        console.log(this.$route.query)
        this.curentProcuctSeries = this.$route.query.series || 2
        this.productLevels = this.$route.query.productLevel.split(',') ? this.$route.query.productLevel.split(',') : [0, 1, 2, 3]
        this.currentLevel = localStorage.getItem('currentLevel') || this.productLevels[0]
        this.curentUnit = localStorage.getItem('currentUnit') || 1
        this.gameType = this.$route.query.gameType || '听力消消乐'
        // const vConsole = new VConsole() // 初始化 vConsole
        // vConsole.hide() // 显示 vConsole 面板
        this.loadUnitInfo()
        this.loadGames()
    },
    methods: {
        getDifficulty () {
            this.loading = true
            this.$axios.post(api.getDifficultyByUnit, { productSeries: this.curentProcuctSeries, productUnit: this.curentUnit, productLevel: this.currentLevel })
                .then(res => {
                    this.difficultyList = res.data.result
                    this.loading = false
                })
        },
        loadUnitInfo () {
            this.loading = true
            var percentage = Enumerable.from(this.unitInfo).where(w => w.unit === this.curentUnit).firstOrDefault()
            if (!percentage) {
                percentage = 0
            }
            this.$axios.post(api.getSoundInfoByLevelAndUnit, { productSeries: this.curentProcuctSeries, productLevel: this.currentLevel, gameType: this.gameType })
                .then(res => {
                    this.unitInfo = res.data.result
                    for (let i = 0; i < this.unitInfo.length; i++) {
                        this.card.cardClass.push('img-level-card')
                    }
                    this.loading = false
                })
        },
        loadGames () {
            var unit = Enumerable.from(this.unitInfo).where(w => w.unit === this.curentUnit).firstOrDefault()
            var percentage = 0
            if (!unit || (unit && unit.percentage >= 100)) {
                percentage = unit.percentage
            }
            this.loading = true
            this.$axios.post(api.getSoundGameData, {
                productSeries: this.curentProcuctSeries,
                productLevel: this.currentLevel,
                productUnit: this.curentUnit,
                gameType: this.gameType,
                percentage: percentage
            })
                .then(res => {
                    this.loading = false
                    if (res.data.result.games.length === 0) {
                        return this.$message.warning('暂无游戏数据，请选择其他单元或级别进行游戏！')
                    }
                    // 初始化当前行并播放
                    this.soundData = res.data.result.games
                })
        },
        saveAnswer (score) {
            // 保存答案到后台
            var unit = Enumerable.from(this.unitInfo).where(w => w.unit === this.curentUnit).firstOrDefault()
            if (!unit || (unit && unit.percentage >= 100)) {
                return // 完成100%进度后不保存
            }
            var para = {
                productSeries: this.curentProcuctSeries,
                productLevel: this.currentLevel,
                productUnit: this.curentUnit,
                gameWords: this.soundData.map(m => m.title).join(','),
                score: score,
                gameType: this.gameType
            }
            this.$axios.post(api.saveScore, para)
                .then(res => {
                    this.loadUnitInfo()
                })
        },
        handleLevelClick (level) {
            localStorage.setItem('currentLevel', level)
            this.currentLevel = level
        },
        handleClick (level, unit) {
            this.card.cardSelected = true
            this.shadow = this.cardSelected ? 'hover' : 'never'
            for (let i = 0; i < this.card.cardClass.length; i++) {
                this.card.cardClass[i] = 'img-level-card'
            }
            this.card.cardClass.splice(unit - 1, 1, 'img-level-card-selected')

            this.curentUnit = unit
            this.currentLevel = level
            localStorage.setItem('currentUnit', unit)
            localStorage.setItem('currentLevel', level)
            this.getDifficulty()
            this.loadGames()
            this.centerDialogVisible = true
        }
    }
}
</script>
<style scoped lang="less">
.game-main {
    padding: 0 15px;
    background-color: #f0f9ff;
    overflow-y: scroll;
}

.game-main-content {
    background-color: #fff;
    border-radius: 6px;
    padding: 0px 15px;
    margin-top: 10px;
}

.img-level-col {
    padding: 10px;
}

.img-level-card {
    background-color: #fffde7;
    margin: 6px 3px;
    text-align: center;
    height: 150px;
}

.img-level-card-selected {
    background-color: #ffc000;
    margin: 6px 3px;
    text-align: center;
    height: 150px;
}

.img-level-col-unit {
    text-align: center;
    display: block;
}

.img-level-card-title {
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
}

.img-level-card-words {
    text-align: center;
    font-weight: 700;
    padding: 5px;
}

.img-level-card-score {
    text-align: center;
    font-weight: 700;
    padding: 5px;
}

.img-level {
    width: 100%;
}

/* 修改整个弹窗的背景色 */
/deep/.el-dialog {
    background: #edf8ff;
}

/deep/.el-dialog--center .el-dialog__body {
    padding: 10px 5px
}
</style>



// WEBPACK FOOTER //
// src/view/game/sound/index.vue